import {useSelector, useDispatch} from 'react-redux'

const useStaffModal = () => {
    const reduxData = useSelector((state) => state.modal.staff.infoStaffModal)
    const {isOpen, onChange} = reduxData
    const dispatch = useDispatch()

    const setData = (isOpen = false, dataUser = null, onChange = () => {}) => {
        dispatch({
            type: 'SET_DATA_MODAL_FORM_LIST',
            payload: 'staff.infoStaffModal',
            data: {
                ...reduxData,
                isOpen,
                dataUser,
                onChange
            }
        })
    }
    return {
        ...reduxData,
        setDataUser: (newDataUser = null) => {
            setData(isOpen, newDataUser, onChange)
        },
        open: (dataUser = null, onChange = () => {}) => {
            setData(true, dataUser, onChange)
        },
        close: () => {
            setData(false)
        },
        toggle: () => {
            setData(!isOpen)
        }
    }
}

export default useStaffModal